import React, {Component} from 'react';
import '../../../Common/Common.css';
import './StencilQuotationForm.css';
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import StencilQuotationImageUploader from "./StencilQuotationImageUploader/StencilQuotationImageUploader";
import Framework from "./StencilQuotationFormFields/Framework";
import Dimensions from "./StencilQuotationFormFields/Dimensions";
import StencilSide from "./StencilQuotationFormFields/StencilSide";
import StencilQuantity from "./StencilQuotationFormFields/StencilQuantity";
import Electropolishing from "./StencilQuotationFormFields/Electropolishing";
import Fiducials from "./StencilQuotationFormFields/Fiducials";
import CustomizedSize from "./StencilQuotationFormFields/CustomizedSize";
import StencilQuotationRemark from "./StencilQuotationFormFields/StencilQuotationRemark";
import {FormattedMessage} from "react-intl";
import StensileQuotationFormData from "./StencilCustomizedSize/StensileQuotationFormData";
import InitialQuotationState from "../InitialQuotationState";
import ContactUs from "../../SiteRoot/Navigation/ContactUs/ContactUs";
import MetaTags from "react-meta-tags";
import PCBQuotationImageUploader from "../PCBQuotationForm/PCBQuotationImageUploader/PCBQuotationImageUploader";
import Modal from "react-bootstrap/lib/Modal";

class StencilQuotationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            fileName: "",
            imageUrl: "",
            imageData: {
                fileUrl: "",
                id: -1,
                imageUrl: "",
                imageUrlBottom: "",
                imageUrlBottomEncoded: "",
                imageUrlTop: "",
                imageUrlTopEncoded: "",
                key: "",
                originalFileName: ""
            },
            gerberDivStyle: this.props.gerberDivStyle,
            gerberError: false,
            isGerberUploading: false
        };

        this.stencilFileUploaderClicked = this.stencilFileUploaderClicked.bind(this);
        this.launchStencilFileUploader = this.launchStencilFileUploader.bind(this);
        this.setParameters = this.setParameters.bind(this);
        this.setStencilGerberError = this.setStencilGerberError.bind(this);
        this.unsetStencilGerberError = this.unsetStencilGerberError.bind(this);
    }

    setStencilGerberError = () => {
        this.setState({
            gerberError: true
        })
    };
    unsetStencilGerberError = () => {
        this.setState({
            gerberError: false
        })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({
                imageData: this.props.gerberImageData,
                fileName: this.props.gerberImageData.originalFileName,
                gerberDivStyle: this.props.gerberDivStyle
            });
        }
    }


    componentWillUnmount() {
        // StensileQuotationFormData.x = 0;
        // StensileQuotationFormData.y = 0;
        // StensileQuotationFormData.conformButton = false;

    }

    componentDidMount() {

        if (this.props.gerberImageData.imageUrl !== "") {
            this.setState({
                imageData: this.props.gerberImageData,
                fileName: this.props.gerberImageData.originalFileName,
                gerberDivStyle: this.props.gerberDivStyle
            });
        }
    }

    setParameters = (event) => {
        if (event.target.name === "dimension") {
            this.props.setDimensions(event);
        } else if (event.target.name === "stencil_qty") {
            const pattern = /^[1-9]([0-9]*)?$/;
            // const pattern = /^[0-9\b]+$/;
            if (event.target.value.match(pattern)) {
                this.props.setQuantity(event);
                // console.log("DONE DUO");
            } else if (event.target.value === "") {
                this.props.setQuantity(event);

            }
        } else if (event.target.name === "stencilRemarks") {
            this.props.setRemarks(event);
        }
    };

    hideModal() {
        this.setState({
            modalShow: false,
        })
    }

    stencilFileUploaderClicked = () => {
        let regEx = /^[\sa-zA-Z0-9_.-]*$/;
        let files = document.getElementById("stencil_uploader").files;
        console.log('uploader ===> ', files[0].name);
        if (regEx.test(files[0].name)) {
            this.setState({
                fileName: files[0].name,
                isGerberUploading: true
            });

            let priceInfoJson = {...this.props.quotation};

            /* remove unwanted properties */
            delete priceInfoJson.fileKey;
            // delete priceInfoJson.smtStencilParam.framework;
            delete priceInfoJson.smtStencilParam.customizeSize;

            /* add additional properties */
            priceInfoJson.country = "HR";
            priceInfoJson.shippingMethod = "dhl";

            const formData = new FormData();
            formData.append('gerberFile', files[0]);
            formData.append('pricingRequest', JSON.stringify(priceInfoJson));

            this.props.setLoadingPriceOnOff(true);

            axios.post(RESOURCE_BASE_URL + 'api/gerber/uploadGerberFile', formData)
                .then((res) => {
                    console.log("GERBER IMAGE DATA DUO STENCIL =====> ", res.data);
                    if (res.data.message === "success") {
                        this.setState({
                            imageData: res.data.gerberDetails,
                            isGerberUploading: false
                        }, () => {
                            this.props.setMainPriceInfo(res.data.mainPriceInfo);
                            this.props.setLoadingPriceOnOff(false);
                            this.props.setGerberImageData(res.data.gerberDetails);
                            InitialQuotationState.gerberFileKey = res.data.gerberDetails.key;
                            if (Object.keys(res.data).length === 0) {
                                this.setStencilGerberError();
                            }
                        });
                    } else if (res.data.message === "without_review") {
                        this.setState({
                            imageData: res.data.gerberDetails,
                            isGerberUploading: false
                        }, () => {
                            // this.props.setMainPriceInfo(res.data.mainPriceInfo);
                            this.props.setLoadingPriceOnOff(false);
                            this.props.setGerberImageData(res.data.gerberDetails);
                            InitialQuotationState.gerberFileKey = res.data.gerberDetails.key;
                            if (Object.keys(res.data).length === 0) {
                                this.setStencilGerberError();
                            }
                        });
                        localStorage.setItem("withoutResult", false);
                        localStorage.setItem("stencilOnly", "y");
                    } else if (res.data.message === "invalid_length_width") {
                        this.setState({
                            imageData: res.data.gerberDetails,
                            isGerberUploading: false
                        }, () => {
                            // this.props.setMainPriceInfo(res.data.mainPriceInfo);
                            this.props.setLoadingPriceOnOff(false);
                            this.props.setGerberImageData(res.data.gerberDetails);
                            InitialQuotationState.gerberFileKey = res.data.gerberDetails.key;
                            if (Object.keys(res.data).length === 0) {
                                this.setStencilGerberError();
                            }
                        });
                        localStorage.setItem("withoutResult", false);
                        localStorage.setItem("stencilOnly", "y");
                    } else {
                        this.setStencilGerberError();
                        this.props.setLoadingPriceOnOff(false);
                        this.setState({
                            isGerberUploading: false
                        })
                    }


                })
                .catch((err) => {
                    console.log("[API] ERROR:  ", err);
                    this.setStencilGerberError();
                    this.props.setLoadingPriceOnOff(false);
                    this.setState({
                        isGerberUploading: false
                    })
                });
        } else {
            console.log("modalSpecialCharacters");
            this.setState({
                modalShow: true,
                isGerberUploading: false,
                fileName: ""
            },() => {
                document.getElementById("stencil_uploader").value = null;
            });
            console.log("fileName ====> ", this.state.fileName);
        }

    };

    launchStencilFileUploader = () => {
        document.getElementById('stencil_uploader').click();
    };

    render() {
        const displayStyle = {
            display: 'block'
        };

        return (
            <div className="pcb-quotation-div" style={displayStyle}>
                <MetaTags>
                    <title>まずは見積スタート！｜メタルマスク製造サービス｜KITCUT PCB</title>
                    <meta property="title" content="まずは見積スタート！｜メタルマスク製造サービス｜KITCUT PCB"/>
                    <meta name="title" content="まずは見積スタート！｜メタルマスク製造サービス｜KITCUT PCB"/>
                    <meta property="description"
                          content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。"
                          lang="ja"/>
                    <meta name="description"
                          content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。"
                          lang="ja"/>
                </MetaTags>
                <div style={this.state.gerberDivStyle}>
                    <StencilQuotationImageUploader fileName={this.state.fileName}
                                                   launchStencilFileUploader={this.launchStencilFileUploader}
                                                   stencilFileUploaderClicked={this.stencilFileUploaderClicked}
                                                   imageData={this.state.imageData}
                                                   gerberDivStyle={this.state.gerberDivStyle}
                                                   gerberError={this.state.gerberError}
                                                   isGerberUploading={this.state.isGerberUploading}/>
                </div>

                <Framework setStencilParams={this.props.setStencilParams}
                           selectedId={this.props.quotation.smtStencilParam.framework}
                           selectedLang={localStorage.getItem("setLang")}/>

                <Dimensions setDimensions={this.setParameters}
                            selectedId={this.props.quotation.smtStencilParam.dimensionsID}
                            stnclParams={this.props.quotation.smtStencilParam.framework}
                            selectedLang={localStorage.getItem("setLang")}/>

                <StencilSide setStencilParams={this.props.setStencilParams}
                             selectedId={this.props.quotation.smtStencilParam.stencilSide}
                             quotation={this.props.quotation}/>

                <StencilQuantity setQuantity={this.setParameters}
                                 selectedId={this.props.quotation.smtStencilParam.stencilQty}
                                 stnclParams={this.props.quotation.smtStencilParam.stencilSide}/>

                <Electropolishing setStencilParams={this.props.setStencilParams}
                                  selectedId={this.props.quotation.smtStencilParam.electropolishing}/>

                <Fiducials setStencilParams={this.props.setStencilParams}
                           selectedId={this.props.quotation.smtStencilParam.fiducials}/>

                {this.props.quotation.smtStencilParam.framework === 0 ?

                    <CustomizedSize setStencilParams={this.props.setStencilParams}
                                    selectedId={this.props.quotation.smtStencilParam.customizeFlag}
                                    stnclParams={this.props.quotation.smtStencilParam.framework}
                                    quotation={this.props.quotation}/> : ''
                }

                {/*{InitialQuotationState.quotation.smtStencilParam.conformBtn ?*/}
                {/*<div>*/}
                {/*Customized Size:Yes*/}
                {/*<div>x is : {InitialQuotationState.quotationType3.smtStencilParam.customizeSizeX}</div>*/}
                {/*<br/>*/}
                {/*<div>y is : {InitialQuotationState.quotationType3.smtStencilParam.customizeSizeY}</div>*/}
                {/*</div>*/}
                {/*:*/}
                {/*""*/}

                {/*}*/}

                <StencilQuotationRemark setRemarks={this.setParameters}
                                        remarks={this.props.quotation.smtStencilParam.orderRemark}/>
                <div className="pcb-with-stencil-msg-div">
                    <ul>
                        <li><FormattedMessage id="app.pcb-quotation.msg-1"
                                              defaultMessage="サポートが必要な方は,"
                                              description=""/>
                            <ContactUs quo={true}/></li>
                        <li><FormattedMessage id="app.pcb-quotation.msg-2"
                                              defaultMessage="ご注文の前には必ずガーバーファイルを確認してください。"
                                              description=""/></li>
                        <li><FormattedMessage id="app.pcb-quotation.msg-3"
                                              defaultMessage="注文方法についてはkitcutpcbの注文方法を参照してください。"
                                              description=""/></li>
                    </ul>
                </div>

                {/*{---popup-modal-special-characters---}*/}
                <Modal dialogClassName="special-character-modal modal-center1" show={this.state.modalShow}>

                    <Modal.Body class="modal-body">
                        <div className="row">
                            <div className="modal-dialog center">
                                ファイル名に次の文字はご利用できません。<br/>
                                “ひらがな”、“カタカナ”、“特殊文字”
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer class="modal-footer">
                        <button className="btn btn-success col-md-2 pull-right delete-btn-yes btn-align"
                                onClick={() => this.hideModal()}>
                            <FormattedMessage id="app.modal.close"
                                              defaultMessage="No"
                                              description=""/>
                        </button>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }
}

export default StencilQuotationForm;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilQuotationForm.js